module.exports = __webpack_public_path__ + "img/vendor-icon-eventplaner.df2c1a90.png";